import React, { useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../../assets/QuallyHireGreen.png";
import { Button } from "antd";
import { DownOutlined, MenuOutlined, PlusOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";

import "./header.css";

function LandingHeader(props) {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const items = [   
    {
      label: (
        <Link className="header-left-link" to="/qhrflowvendorconnect">
          VendorConnect
        </Link>
      ),
      key: "1",
    },
    {
      label: (
        <Link className="header-left-link" to="/careerWebsites">
          CareerLinks
        </Link>
      ),
      key: "2",
    },
    {
      label: (
        <Link className="header-left-link" to="">
          Attendance and Leaves Tracker
        </Link>
      ),
      key: "3",
    },
  ];

  const handleContactSales = () => {    navigate("/qhrflowcontact");};

  const handleNews = () => {};

  return (
    <>
      <div className="header-wrapper">
        <div className="header-container">
          <div className="landing-header-left">
            <div className="header-logo">
              <div className="header-logo-name" onClick={()=>navigate("/home")}>QUALLYHIRE AI</div>
            </div>
            <div className="header-menu">
              <ul className="header-menu">
                <Link to="/">Home</Link>
                <Link to="/qhrflow">QHRFlow</Link>
                <Link to="/nujobs">NuJobs</Link>
                <Link to="/qhrset">QHRSET</Link>
                <li>
                  <Dropdown
                    menu={{
                      items,
                    }}
                  >
                    <a
                      onClick={(e) => e.preventDefault()}
                      style={{ color: "black" }}
                    >
                      <Space>
                        Other Products
                        <DownOutlined />
                      </Space>
                    </a>
                  </Dropdown>
                </li>
              </ul>
            </div>
            <div className="header-hamburger">
              <MenuOutlined onClick={() => setHamburgerOpen(!hamburgerOpen)} />
            </div>
          </div>
          <div className="header-sign">
            <Button
              className="sign-button"
              onClick={() => handleContactSales()}
            >
              Talk to Sales
            </Button>
          </div>
        </div>
      </div>

      <div className={`header-menu-responsive ${hamburgerOpen ? "open" : ""}`}>
        <div className="header-menu-responsive-wrapper">
          <ul
            className="header-menu-responsive-list"
            onClick={() => navigate("/")}
          >
            Home
          </ul>
        </div>
        <hr className="header-menu-responsive-hr" />
        <div
          className="header-menu-responsive-wrapper"
          onClick={() => setProductDropdownOpen(!productDropdownOpen)}
        >
          <ul className="header-menu-responsive-list">Products</ul>
          <button className="header-menu-responsive-btn">
            <PlusOutlined />
          </button>
        </div>
        <hr className="header-menu-responsive-hr" />

        <div
          className={`header-menu-product-dropdown ${
            productDropdownOpen ? "open" : ""
          }`}
        >
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/qhrflow")}
            >
              QHRFlow
            </ul>
          </div>
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/nujobs")}
            >
              NuJobs
            </ul>
          </div>
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/qhrset")}
            >
              QHRSET
            </ul>
          </div>          
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/qhrflowvendorconnect")}
            >
              VendorConnect
            </ul>
          </div>          
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/careerWebsites")}
            >
              CareerLinks
            </ul>
          </div>
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/")}
            >
              BenchHire Platform
            </ul>
          </div>
          <div className="header-menu-responsive-wrapper">
            <ul
              className="header-menu-responsive-list"
              onClick={() => navigate("/")}
            >
              Employee Register and Leave Mgmt.
            </ul>
          </div>
          <hr className="header-menu-responsive-hr" />
        </div>
      </div>
    </>
  );
}

export default LandingHeader;
